<template>
  <div class="common-tips">
    <img class="common-tips-bg" :src="pageInfo.popup.common_popup" />
    <a class="common-tips-close" @click="closeCommonTips" href="javascript:;">
      <img :src="pageInfo.popup.close_btn" />
    </a>
    <p class="common-tips-content" :style="tipsCss">{{ commonTips }}</p>
    <a href="javascript:;" class="common-tips-sure-btn" @click="closeCommonTips">
      <img :src="pageInfo.popup.sure_btn" />
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      pageInfo: window.pageInfo,
      tipsCss: `color:${window.pageInfo.color.tips}`,
    };
  },
  computed: {
    ...mapGetters(["commonTips"]),
  },
  methods: {
    closeCommonTips() {
      this.$store.commit("updateCommonTips", "");
    },
  },
};
</script>
